export { default as AdminNotes } from './AdminNotes';



// WEBPACK FOOTER //
// ./src/routes/Admin/AdminNotes/index.ts